/**
 * Panel görünüm tercihi — light / dark / system.
 *
 * - light/dark: sabit tercih
 * - system: cihazın OS/tarayıcı `prefers-color-scheme` ayarını izler (saat değil)
 *
 * localStorage = anında cache. Hesap senkronu: GET/PUT /api/me/preferences
 */

export const PANEL_THEME_STORAGE_KEY = "patientmesh-panel-theme";

export const PANEL_THEME_PREFERENCES = ["light", "dark", "system"];

export function normalizePanelThemePreference(value) {
  if (value === "dark" || value === "system" || value === "light") return value;
  return "light";
}

export function readSystemColorScheme() {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return "light";
  }
  try {
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
  } catch {
    return "light";
  }
}

export function resolvePanelThemeMode(preference, systemMode = readSystemColorScheme()) {
  const pref = normalizePanelThemePreference(preference);
  if (pref === "system") return systemMode === "dark" ? "dark" : "light";
  return pref;
}

export function readStoredPanelPreference() {
  if (typeof window === "undefined") return "light";
  try {
    return normalizePanelThemePreference(window.localStorage.getItem(PANEL_THEME_STORAGE_KEY));
  } catch {
    return "light";
  }
}

export function persistPanelThemePreference(preference) {
  try {
    window.localStorage.setItem(
      PANEL_THEME_STORAGE_KEY,
      normalizePanelThemePreference(preference)
    );
  } catch {
    /* private mode / disabled storage */
  }
}

export function subscribeSystemColorScheme(onChange) {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return () => {};
  }
  let media;
  try {
    media = window.matchMedia("(prefers-color-scheme: dark)");
  } catch {
    return () => {};
  }
  const handle = (event) => {
    onChange(event.matches ? "dark" : "light");
  };
  if (typeof media.addEventListener === "function") {
    media.addEventListener("change", handle);
    return () => media.removeEventListener("change", handle);
  }
  if (typeof media.addListener === "function") {
    media.addListener(handle);
    return () => media.removeListener(handle);
  }
  return () => {};
}
